import React from 'react';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import Layout from 'Components/Layout';
import RouteLoading from 'Components/RouteLoading';
import errorController from 'Components/ErrorScreens';
import { Status } from 'Common/parameterEnums';
import CreateExpressionForm from 'Components/CreateExpressionForm';

const CreateExpression: React.FC<{}> = () => {
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active'])
        }
    });
    const initialValues: ParameterExpressionFormSchema = {
        displayName: '',
        systemName: '',
        description: '',
        expression: {
            expText: '',
            inputs: {},
            functionCalls: []
        },
        isScriptValidated: false,
        revalidateScript: false,
        tppType: undefined,
        status: Status.DRAFT
    };

    if (parametersAPI.isLoading || parametersAPI.isFetching) return <RouteLoading />;
    if (parametersAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error]);
        return errorCmp;
    }

    return (
        <Layout>
            <CreateExpressionForm initialValues={initialValues} parameterData={parametersAPI.data} />
        </Layout>
    );
};

export default CreateExpression;
